import styled from "styled-components";

export const Menu = styled.ul`
  display: flex;
  list-style: none;
  margin-bottom: 1rem;
  margin-top: 2rem;

  li {
    width: 3rem;
    height: 3rem;
    font-size: 1.3rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.1);
    font-weight: bold;
    position: relative;
    cursor: not-allowed;
    transition: all 0.1s ease;

    &.completed {
      cursor: pointer;
      color: #1ab394;
      font-size: 1.6rem;
    }

    &:not(:last-child) {
      margin-right: 2.85rem;

      &:after {
        width: 2.85rem;
        height: 2px;
        position: absolute;
        content: "";
        right: -2.85rem;
        top: 50%;
        margin-top: -1px;
        background: rgba(0, 0, 0, 0.1);
      }
    }

    &.active {
      background-color: ${localStorage.getItem("@ecorban-app:theme")
        ? localStorage.getItem("@ecorban-app:theme")
        : "#2f4050"};
      color: #ffffff;
      cursor: initial;
    }
  }
`;

export const Passos = styled.div`
  display: flex;

  fieldset {
    margin-top: 1rem;
    width: 380px;
    margin-bottom: 20px;
    padding-bottom: 10px;
  }

  input {
    text-align: center;
    font-weight: bold;
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;

    input {
      cursor: pointer;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Forms/Atendimento/styles.js